module.exports = __webpack_public_path__ + "static/us_lodi-9c3dad7b2dbc683487994d0b239309f4.png";